import React from "react";
import { motion, useTransform } from "framer-motion";
import { scrollProgressMV } from "../../lib/scrollMotion";

// Ambient royal-dark decor confined to the left/right side gutters (never over content).
// Scroll-linked parallax driven by the shared Lenis scroll MotionValue (no useScroll race).
// Hidden below lg to avoid overlap on narrow screens.
export const BackgroundDecor = () => {
  const sp = scrollProgressMV;
  const yUp = useTransform(sp, [0, 1], [0, -260]);
  const yDown = useTransform(sp, [0, 1], [0, 300]);
  const yUpSlow = useTransform(sp, [0, 1], [0, -140]);
  const yDownSlow = useTransform(sp, [0, 1], [0, 180]);
  const spin = useTransform(sp, [0, 1], [0, 140]);
  const spinBack = useTransform(sp, [0, 1], [0, -160]);
  const railFill = useTransform(sp, [0, 1], [0, 1]);
  const glowFade = useTransform(sp, [0, 0.5, 1], [0.5, 1, 0.5]);

  return (
    <div className="pointer-events-none fixed inset-0 z-0 hidden overflow-hidden lg:block" aria-hidden="true">
      {/* Base side rails */}
      <div className="absolute left-[4.5%] top-0 h-full w-px bg-gradient-to-b from-transparent via-white/[0.05] to-transparent" />
      <div className="absolute right-[4.5%] top-0 h-full w-px bg-gradient-to-b from-transparent via-white/[0.05] to-transparent" />
      {/* Animated gold rail progress */}
      <motion.div
        style={{ scaleY: railFill }}
        className="absolute left-[4.5%] top-0 h-full w-px origin-top bg-gradient-to-b from-amber/50 via-amber/20 to-transparent"
      />
      <motion.div
        style={{ scaleY: railFill }}
        className="absolute right-[4.5%] top-0 h-full w-px origin-top bg-gradient-to-b from-gold/40 via-gold/15 to-transparent"
      />

      {/* LEFT gutter shapes */}
      <motion.div style={{ y: yUp, opacity: glowFade }} className="absolute left-[-1%] top-[14%] h-52 w-52 rounded-full bg-amber/[0.07] blur-[70px]" />
      <motion.div style={{ y: yDown, rotate: spin }} className="absolute left-[2.5%] top-[42%] h-28 w-28 rounded-full border border-amber/15" />
      <motion.div style={{ y: yDown, rotate: spin }} className="absolute left-[3.2%] top-[43.2%] h-24 w-24 rounded-full border border-amber/[0.06]" />
      <motion.div style={{ y: yUpSlow }} className="absolute left-[6%] top-[68%] h-1.5 w-1.5 rounded-full bg-amber/50" />
      <motion.div style={{ y: yDownSlow, rotate: spinBack }} className="absolute left-[1.5%] top-[80%] h-16 w-16 rotate-45 border border-gold/12" />

      {/* RIGHT gutter shapes */}
      <motion.div style={{ y: yDown, opacity: glowFade }} className="absolute right-[-1%] top-[22%] h-56 w-56 rounded-full bg-gold/[0.06] blur-[80px]" />
      <motion.div style={{ y: yUp, rotate: spinBack }} className="absolute right-[2.5%] top-[56%] h-24 w-24 rotate-45 border border-amber/14" />
      <motion.div style={{ y: yUpSlow }} className="absolute right-[5.5%] top-[34%] h-2 w-2 rounded-full bg-amber/50" />
      <motion.div style={{ y: yDownSlow }} className="absolute right-[7%] top-[76%] h-1.5 w-1.5 rounded-full bg-gold/50" />
      <motion.div style={{ y: yUp, rotate: spin }} className="absolute right-[1%] top-[10%] h-20 w-20 rounded-full border border-amber/10" />
    </div>
  );
};
